import { render, staticRenderFns } from "./RecordVideo.vue?vue&type=template&id=5d543023&scoped=true&"
import script from "./RecordVideo.vue?vue&type=script&lang=js&"
export * from "./RecordVideo.vue?vue&type=script&lang=js&"
import style0 from "./RecordVideo.vue?vue&type=style&index=0&id=5d543023&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d543023",
  null
  
)

export default component.exports